// import jQuery from 'CommonScripts/jquery-1.10.2';

(function (window, document, $) {
     
    $(document).ready(function () {

        (function () {
            var Colour = {
                dom: {
                    base: $('.colours-wrapper'),
                    colour: $('.colours-wrapper .colour'),
                    addSamples: $('aside.samples'),
                    sampleCount: $('aside.samples span.sampleCount'),
                    activeColour: null,
                    clonedColour: function () {
                        return $dom.activeColour.clone().addClass('addtobasket');
                    }
                },
                set: {
                    colourCount: 0,
                    tooltip: {
                        offset: null
                    },
                    scrollTop: null,
                    width: null,
                    colourOffset: null,
                    basketOffset: null
                },
                fn: {
                    /* Change the count on the colour samples page, if it exists */
                    changeColourSampleCount: function () {
                        if ($dom.addSamples.length > 0) {
                            $set.colourCount = $dom.colour.find('input:checked').length;
                            $dom.sampleCount.text($set.colourCount);

                            $dom.colour.removeClass('selected');
                            $dom.colour.find('input:checked').closest('.colour').addClass('selected');

                            if ($set.colourCount > 0) {
                                $dom.addSamples.show();
                            } else {
                                $dom.addSamples.hide();
                            }

                            $fn.animateSampleToBasket();
                        }
                    },
                    animateSampleToBasket: function () {
                        /* Calculate the offsets of the active colour and the basket */
                        $set.colourOffset = $dom.activeColour.offset();
                        $set.basketOffset = $dom.addSamples.offset();

                        /* Add the cloned colour at the end of the body and animate */
                        $dom.clonedColour();
                        $dom.clonedColour().appendTo($('body'))
                            .wrap('<div class="colours-wrapper"></div>')
                            .css({ left: $set.colourOffset.left, top: $set.colourOffset.top - $(window).scrollTop() })
                            .animate({ left: $set.basketOffset.left + ($dom.addSamples.width() / 2), top: $set.basketOffset.top - $(window).scrollTop() }, 500)
                            .fadeOut(500, function () {
                                $(this).parent().remove();
                            });
                    }
                }
            },
            /* Add quick access variables to be used in local function
             * Keep main variable name in case it needs to be shared with other JS files
             */
            $dom = Colour.dom,
            $set = Colour.set,
            $fn = Colour.fn;

            /* Add functionality to colour samples */
            $dom.base.on({
                mouseenter: function () {
                    var colour = $(this),
                        tooltip = colour.find('.colour-tooltip');

                    colour.removeClass('bottom left');

                    $set.tooltip.offset = tooltip.offset();
                    $set.scrollTop = $(window).scrollTop();
                    $set.width = $(window).width();

                    if ($set.tooltip.offset.top < ($set.scrollTop + $('.main-title-wrapper').height())) {
                        colour.addClass('bottom');
                    }

                    if (($set.tooltip.offset.left + tooltip.width()) > $set.width) {
                        colour.addClass('left');
                    }
                }
            }, '.colour');

            /* Change the quantity of cloth samples in minibasket and show when > 0 */
            $dom.base.on({
                change: function () {
                    $dom.activeColour = $(this).closest('.colour');
                    $fn.changeColourSampleCount();
                }
            }, 'input');

        })();

    });

})(window, document, jQuery);